import { BiteLogTransactCampusCardEvent } from './bite_log_transact_campus_card_event.js';

export function name(event: BiteLogTransactCampusCardEvent): string {
  switch (event) {
    case BiteLogTransactCampusCardEvent.BalanceInquirySuccess:
      return 'balance-inquiry-success';
    case BiteLogTransactCampusCardEvent.BalanceInquiryError:
      return 'balance-inquiry-error';
    case BiteLogTransactCampusCardEvent.SaleTransaction:
      return 'sale-transaction';
    case BiteLogTransactCampusCardEvent.SaleTransactionError:
      return 'sale-transaction-error';
    case BiteLogTransactCampusCardEvent.RefundTransaction:
      return 'refund-transaction';
    case BiteLogTransactCampusCardEvent.RefundTransactionError:
      return 'refund-transaction-error';
    case BiteLogTransactCampusCardEvent.AuthorizeLimitSuccess:
      return 'authorize-limit-success';
    case BiteLogTransactCampusCardEvent.AuthorizeLimitError:
      return 'authorize-limit-error';
    case BiteLogTransactCampusCardEvent.RetryAttempt:
      return 'retry-attempt';
    case BiteLogTransactCampusCardEvent.ConnectError:
      return 'connect-error';
    case BiteLogTransactCampusCardEvent.ParseError:
      return 'parse-error';
  }
}
